import { render, staticRenderFns } from "./compare5.vue?vue&type=template&id=e9021a34&scoped=true"
import script from "./compare5.vue?vue&type=script&lang=js"
export * from "./compare5.vue?vue&type=script&lang=js"
import style0 from "./compare5.vue?vue&type=style&index=0&id=e9021a34&prod&lang=css"
import style1 from "./compare5.vue?vue&type=style&index=1&id=e9021a34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9021a34",
  null
  
)

export default component.exports